"use server";

import { prisma } from "@/lib/prisma";
import { cookies } from "next/headers";
import { decrypt } from "@/lib/auth";

interface ContactFormPayload {
    siteId: string;
    name: string;
    email: string;
    phone?: string;
    subject: string;
    message: string;
}

export async function submitContactAction(data: ContactFormPayload) {
    try {

        if (!data.siteId || !data.name || !data.email || !data.subject || !data.message) {
            return { success: false, error: "Lütfen gerekli tüm alanları doldurun." };
        }

        // Yeni şemaya göre veritabanına kayıt
        await prisma.contactMessage.create({
            data: {
                siteId: data.siteId,
                type: "CONTACT",
                name: data.name,
                email: data.email,
                phone: data.phone || null,
                subject: data.subject,
                message: data.message,
                status: "UNREAD"
            }
        });


        return { success: true };
    } catch (error) {
        console.error("İletişim Formu Kayıt Hatası:", error);
        return { success: false, error: "Sistemsel bir hata oluştu. Lütfen telefon ile ulaşmayı deneyin." };
    }
}

export async function getContactMessagesAction(filters: { status: string, type: string, search: string }) {
    try {
        const cookieStore = await cookies();
        const sessionToken = cookieStore.get("tenant_session")?.value;

        if (!sessionToken) return { success: false, error: "Oturum bulunamadı." };
        const decoded = await decrypt(sessionToken);
        if (!decoded || !decoded.siteId) return { success: false, error: "Yetkisiz işlem." };

        const siteId = decoded.siteId;

        // Filtreleri Prisma'nın anlayacağı Query yapısına çeviriyoruz
        const whereClause: any = { siteId };

        // Durum Filtresi
        if (filters.status && filters.status !== 'all') {
            whereClause.status = filters.status;
        }

        // Tip Filtresi (Şu an formu CONTACT olarak ayarlamıştık, ama diğer tipler de gelebilir)
        if (filters.type && filters.type !== 'all') {
            whereClause.type = filters.type;
        }

        // Arama (İsim, e-posta, konu veya mesaj içeriğinde ara)
        if (filters.search && filters.search.trim() !== '') {
            whereClause.OR = [
                { name: { contains: filters.search, mode: 'insensitive' } },
                { email: { contains: filters.search, mode: 'insensitive' } },
                { subject: { contains: filters.search, mode: 'insensitive' } },
                { message: { contains: filters.search, mode: 'insensitive' } },
            ];
        }

        const messages = await prisma.contactMessage.findMany({
            where: whereClause,
            orderBy: { createdAt: 'desc' } // En yeniler en üstte
        });

        return { success: true, data: messages };
    } catch (error) {
        console.error("Mesajlar Çekilirken Hata:", error);
        return { success: false, error: "Mesajlar yüklenemedi." };
    }
}

export async function updateMessageStatusAction(messageId: string, newStatus: any) {
    try {
        const cookieStore = await cookies();
        const sessionToken = cookieStore.get("tenant_session")?.value;

        if (!sessionToken) return { success: false, error: "Oturum bulunamadı." };
        const decoded = await decrypt(sessionToken);
        if (!decoded || !decoded.siteId) return { success: false, error: "Yetkisiz işlem." };

        // Güvenlik: Sadece kendi sitesine ait mesajı güncelleyebilir
        const updatedMessage = await prisma.contactMessage.update({
            where: { id: messageId, siteId: decoded.siteId },
            data: { status: newStatus }
        });

        return { success: true, data: updatedMessage };
    } catch (error) {
        console.error("Durum Güncelleme Hatası:", error);
        return { success: false, error: "Durum güncellenemedi." };
    }
}